import styled from 'styled-components'
import theme from '../../styles/theme'

const CollapseIcon = styled.img`
  width: 2rem;
  position: absolute;
  height: 2rem;
  z-index: 30;
  top: 1.5rem;
  right: 1rem;
`

const ExpandedTextHolder = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding: 4rem 2rem;
  padding-bottom: 16vh;
  position: relative;
  p {
    font-style: italic;
    font-size: 1.2rem;
  }
  h4 {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    font-style: italic;
  }

  h5 {
    margin: 0;
    font-family: ${theme.fonttitle4};
    padding: 0;
    font-size: 0.8rem;
    font-weight: 300;
  }
`

const IconBeneficio = styled.img`
  max-height: 100px;
  max-width: 100px;
  display: inline-flex;
`

const Container = styled.section`
  position: relative;
  padding-top: 5vh;
  max-width: ${theme.overWidth};
  margin-left: auto;
  margin-right: auto;
  background-color: #ffba25;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const ExpandedHolder = styled.div`
  font-family: ${theme.fonttitle2};
  font-style: italic;
  font-weight: 900;
  font-size: 3rem;
  line-height: 75%;
  color: ${theme.clearcolor};
  background-color: ${theme.clear};
  overflow: hidden;
  width: 100%;
  max-height: 0;
  height: auto;
  transition: all 1s;
  position: relative;
  &.active {
    max-height: 200vh;
    background-color: ${theme.deepBlue};
  }
`

const Content = styled.div`
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 4fr 6fr;
  grid-gap: 1rem;
  padding: 5vh 10vw 16vh 10vw;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 990px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 660px) {
    grid-template-columns: 1fr;
  }
  .compromiso-image {
    /* width: 40vw; */
    max-width: 100%;
    @media (max-width: 500) {
      /* width: 20vw; */
    }
  }
`
const TextHolder = styled.div`
  color: black;
  height: 100%;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;

  margin-right: auto;
  & ul {
    list-style-type: none;
  }
  & li {
    flex-direction: row;
    display: inline-flex;
    width: 100%;
    padding-bottom: 1.5rem;
  }
  & h2 {
    font-family: ${theme.fonttitle4};
    font-size: 2.5rem;
  }
  & p {
    padding-left: 1.5rem;
    align-items: center;
    justify-content: center;
  }
`

const Button = styled.div`
  transition: all 300ms ease-out;
  font-size: 1.2rem;
  letter-spacing: 0.04rem;
  font-family: ${theme.fonttitle4};
  font-weight: 700;
  width: auto;
  display: block;
  max-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: black;
  cursor: pointer;
  user-select: none;
  margin-left: 0;
  margin-right: auto;
  border-radius: 2rem;
  padding: 1rem 1rem;
  margin-block-start: 1rem;
  margin-block-end: 1rem;

  &:hover,
  &:active {
    color: ${theme.color};
    background-color: black;
  }
`

export {
  Container,
  Content,
  TextHolder,
  Button,
  ExpandedHolder,
  ExpandedTextHolder,
  CollapseIcon,
  IconBeneficio,
}
